<template>
<div class="dark-switcher">
	<svg width="17" height="17" :class="{active: $store.state.dark}" enable-background="new 0 0 438.277 438.277" version="1.1" viewBox="0 0 438.277 438.277" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><path d="m428.76 300.1c-0.664-3.81-2.334-7.047-4.996-9.713-5.9-5.903-12.752-7.142-20.554-3.716-20.937 9.708-42.641 14.558-65.097 14.558-28.171 0-54.152-6.94-77.943-20.838-23.791-13.894-42.631-32.736-56.525-56.53-13.899-23.793-20.844-49.773-20.844-77.945 0-21.888 4.333-42.683 12.991-62.384 8.66-19.7 21.176-36.973 37.543-51.82 6.283-5.898 7.713-12.752 4.287-20.557-3.236-7.801-9.041-11.511-17.415-11.132-29.121 1.141-56.72 7.664-82.797 19.556-26.076 11.895-48.489 27.547-67.238 46.965-18.747 19.414-33.595 42.399-44.54 68.95-10.942 26.553-16.416 54.39-16.416 83.511 0 29.694 5.806 58.054 17.416 85.082 11.613 27.028 27.218 50.344 46.824 69.949 19.604 19.599 42.92 35.207 69.951 46.822 27.028 11.607 55.384 17.415 85.075 17.415 42.64 0 81.987-11.563 118.05-34.69 36.069-23.124 63.05-54.006 80.944-92.645 1.524-3.423 1.951-7.036 1.28-10.838zm-122.19 84.064c-24.646 11.711-50.676 17.562-78.087 17.562-24.743 0-48.39-4.853-70.947-14.558-22.554-9.705-41.971-22.695-58.246-38.972-16.271-16.272-29.259-35.686-38.97-58.241-9.707-22.556-14.561-46.203-14.561-70.948 0-40.922 12.135-77.466 36.403-109.64 24.266-32.165 55.531-53.959 93.788-65.379-19.795 31.405-29.694 65.379-29.694 101.93 0 34.644 8.564 66.715 25.697 96.223 17.128 29.499 40.446 52.811 69.95 69.948 29.499 17.129 61.565 25.694 96.211 25.694 10.656 0 21.129-0.855 31.408-2.57-17.318 20.938-38.307 37.255-62.952 48.951z"/></svg>
		<toggle-button
			@change="darkToggle"
			:value="$store.state.dark"
			:sync="true"
			:speed="100"
			:color="{checked: this.$store.state.dark ? '#616161' : '#c4c4c4', unchecked: this.$store.state.dark ? '#616161' : '#c4c4c4', disabled: '#CCCCCC'}">
		</toggle-button>
</div>
</template>

<script>
export default {
methods: {
	darkToggle(){setTimeout(() => {
			this.$store.commit("changeDarken");
		}, 200);
	}
    }
}
</script>

<style lang="scss" scoped>
@import './../../styles/variables.scss';
.dark-switcher {
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	max-width: 90px;
	padding: 0 5px;
	overflow: hidden;

	svg {
		fill: #c4c4c4;

		&.active {
			fill: #3d3df3;
		}

		.dark & {
		fill: $dark-text;

			&.active {
				fill: #3d3df3;
			}
		}
	}
}
</style>
